/* eslint-disable import/prefer-default-export */

/**
 * @param {HTMLFormElement} element - Google reCAPTCHA captcha input element
 */
export const reset = element => {
    if (element) {
        window.grecaptcha.ready(function () {
            window.grecaptcha
                .execute(element.dataset.sitekey, {action: element.dataset.action})
                .then(token => (element.value = token));
        });
    }
};
